import React from "react";
import { Polyline, Tooltip } from "react-leaflet";

export const ConvergenceLayer = ({ pairs = [] }) => (
  <>
    {pairs.map((c) => (
      <Polyline
        key={`conv-${c.id}`}
        positions={[[c.aLat, c.aLon], [c.bLat, c.bLon]]}
        pathOptions={{ color: "#FFB347", weight: 2.5, opacity: 0.9, dashArray: "2 6" }}
      >
        <Tooltip permanent direction="center" className="convergence-label">
          <div style={{ textAlign: "center", lineHeight: 1.25 }}>
            <div>{c.distance_mi.toFixed(1)} mi</div>
            <div className="conv-names">{c.nameA} ↔ {c.nameB}</div>
          </div>
        </Tooltip>
      </Polyline>
    ))}
  </>
);

export default ConvergenceLayer;
